export const ru = {
    more: 'Подробнее',
    'not-meet-requirements': 'Не отвечает требованиям',
    repeat: 'Повторить',
    uploading: 'Загружается'
};
